import React, { useState, useEffect } from "react";
import { Drawer, Spin } from "antd";
import "./rightDrawer.css";
import { formatTime } from "../common/common";
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'
const RightDrawer = ({ isOpen, onClose, onApplyParams }) => {
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  const purposeTag = (purpose) => {
    return purpose === "Purchase" ? "Purchase" : purpose === "RateTermRefi" ? "Refinance" : "CashOut"
  }
  const getPropertyValue = (item) => {
    // console.log('item: ', item)
    return (item.parameters.loanAmount / item.parameters.LTV * 100)
  }

  useEffect(() => {
    // console.log('RightDrawer isOpen prop changed:', isOpen);
    isOpen && fetchHistory();
    setOpen(isOpen);
  }, [isOpen]);

  // const history = [
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "900",
  //     ltv: "80%",
  //     createdTime: "2025-05-15 11:30:00",
  //   },
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "800",
  //     ltv: "80%",
  //     createdTime: "2025-05-14 10:30:00",
  //   },
  //   {
  //     purpose: "Purchase",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "800",
  //     ltv: "80%",
  //     createdTime: "2025-05-14 18:00:00",
  //   },
  //   {
  //     purpose: "Refinance",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "100",
  //     ltv: "80%",
  //     createdTime: "2025-04-16 12:00:00",
  //   },
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-12 12:00:00",
  //   },
  //   {
  //     purpose: "CashOut",
  //     occupancy: "Primary",
  //     propertyValue: "500",
  //     fico: "700",
  //     ltv: "80%",
  //     createdTime: "2025-05-13 12:56:00",
  //   },
  // ];

  const [history, setHistory] = useState([]);
  const formatHistory = (data) => {
    return data.map((item) => ({
      ...item,
      purpose: item.parameters.purpose || "",
      occupancy: item.parameters.occupancy || "",
      propertyValue: item.parameters.propertyValue || "",
      fico: item.parameters.FICO || "",
      ltv: item.parameters.LTV || "",
      createdTime: item.created_at || "",
    }));
  };
  const fetchHistory = () => {
    setLoading(true);
    fetch("/los/priceengine/getsearchhistory?source=ppe", {
      method: "GET",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("ZeitroA"),
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        // console.log("history: ", data);
        setHistory(formatHistory(data === null ? [] : data));
      }).finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    fetchHistory();
  }, []);

  const todayHistory = history.filter((item) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const itemDate = new Date(item.createdTime);
    return itemDate >= today && itemDate < tomorrow;
  });
  // console.log("todayHistory: ", todayHistory);

  const yesterdayHistory = history.filter((item) => {
    // 获取昨天的开始和结束时间
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    const yesterdayEnd = new Date(yesterday);
    yesterdayEnd.setDate(yesterdayEnd.getDate() + 1);

    const itemDate = new Date(item.createdTime);
    return itemDate >= yesterday && itemDate < yesterdayEnd;
  });
  // console.log("yesterdayHistory: ", yesterdayHistory);

  const last7DaysHistory = history.filter((item) => {
    // 获取7天前的开始时间
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    sevenDaysAgo.setHours(0, 0, 0, 0);

    // 获取昨天的结束时间
    const yesterdayEnd = new Date();
    yesterdayEnd.setDate(yesterdayEnd.getDate() - 1);
    yesterdayEnd.setHours(0, 0, 0, 0);

    const itemDate = new Date(item.createdTime);
    return itemDate >= sevenDaysAgo && itemDate < yesterdayEnd;
  });
  // console.log("last7DaysHistory: ", last7DaysHistory);

  const last30DaysHistory = history.filter((item) => {
    // 获取30天前的开始时间
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    thirtyDaysAgo.setHours(0, 0, 0, 0);

    // 获取7天前的结束时间
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    sevenDaysAgo.setHours(0, 0, 0, 0);

    const itemDate = new Date(item.createdTime);
    return itemDate >= thirtyDaysAgo && itemDate < sevenDaysAgo;
  });
  // console.log("last30DaysHistory: ", last30DaysHistory);

  const formatOccupancy = (occupancy) => {
    switch(occupancy){
      case "PRIMARY":
        return "Primary"
      case "SECOND_HOME":
        return "Second Home"
      case "INVESTMENT":
        return "Investment"
      default:
        return occupancy
    }
  }
  const HistoryItem = ({ item }) => {
    return (
      <div
        className="right-drawer-content-item cursor-pionter"
        onClick={(e) => {
          e.preventDefault();
          // escrowWaiver is the INVERSE of isImpound. Prefer the stored isImpound and
          // only derive it for older rows saved before that field was persisted.
          item.parameters.isImpound =
            item.parameters.isImpound !== undefined
              ? !!item.parameters.isImpound
              : !item.parameters.escrowWaiver
          const finalParams = {
            ...item,
          }
          if(item.parameters.searchBy === "rate") {
            finalParams.parameters.targetRate = item.parameters.targetPrice
          }
          onApplyParams(finalParams);
          track(STATSIG.RATES.RECENT_SEARCH_BUTTON, 'item_open', { type: 'item_open' })
          // setOpen(false);
        }}
      >
        <div className="right-drawer-content-item-title">
          <span className={`purpose-tag ${purposeTag(item.purpose)}`}>{item.purpose === "Purchase" ? "Purchase" : item.purpose === "RateTermRefi" ? "Refinance" : "Cash Out"}</span>
          <span className="time">{formatTime(item.createdTime)}</span>
        </div>
        <div className="right-drawer-content-item-content">
          <div className="occupancy">
            <span>{formatOccupancy(item.occupancy)}</span>
          </div>
          <div className="property-value">
            <span>${(item.propertyValue || getPropertyValue(item)) / 1000}K</span>
          </div>
          <div className="fico">
            <span>FICO: {item.fico}</span>
          </div>
          <div className="ltv">
            <span>{item.ltv ? Number(item.ltv).toFixed(2) : '0'}% LTV</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Drawer
      width={440}
      classNames={{
        header: "right-drawer-header",
        body: "right-drawer-body",
      }}
      title="Recent search"
      closable={{ "aria-label": "Close Button" }}
      onClose={handleClose}
      open={open}
    >
      {loading ? 
      <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 20}}><Spin></Spin></div>
      :
      <div className="right-drawer-content">
        {/* today */}
        {todayHistory.length > 0 && (
          <div>
            <div className="right-drawer-content-title">Today</div>
            {todayHistory.map((item, index) => (
              <HistoryItem key={index} item={item} />
            ))}
          </div>
        )}
        {/* yesterday */}
        {yesterdayHistory.length > 0 && (
          <div>
            <div className="right-drawer-content-title">Yesterday</div>
            {yesterdayHistory.map((item, index) => (
              <HistoryItem key={index} item={item} />
            ))}
          </div>
        )}

        {/* last 7 days */}
        {last7DaysHistory.length > 0 && (
          <div>
            <div className="right-drawer-content-title">Previous 7 days</div>
            {last7DaysHistory.map((item, index) => (
              <HistoryItem key={index} item={item} />
            ))}
          </div>
        )}

        {/* last 30 days */}
        {last30DaysHistory.length > 0 && (
          <div>
            <div className="right-drawer-content-title">Past 30 days</div>
            {last30DaysHistory.map((item, index) => (
              <HistoryItem key={index} item={item} />
            ))}
          </div>
        )}
      </div>}
    </Drawer>
  );
};

export default RightDrawer;
